import { useSelector } from 'react-redux';
import { Project } from '@bimone/bimtrack-core';
import { ApplicationState } from '../redux/store';
import { updateProjects } from '../redux/reducers/entities';

export interface UseProjectsResult {
  states: {
    projects?: Project[];
  };
  actions: {
    updateProjects: typeof updateProjects;
  };
}

export function useProjects(): UseProjectsResult {
  return {
    states: {
      projects: useSelector<ApplicationState, Project[] | undefined>(state => state.entities.projects),
    },
    actions: {
      updateProjects,
    },
  };
}
